export default __webpack_public_path__ + "static/media/modern-landing-large.f0e5f71f.jpg";